<template>
    <div class="SiteHero">
        <Container>
            <div class="main">
                <h1>Save Time With Digital Ticketing.</h1>
                <p>Replace your paper haul sheets with an easy to use digital solution designed to save time and money.</p>
                <Button to="/signup" class="primary lg">Try DumpTek Free</Button>
            </div>

            <div class="aside">
                <Video videoId="3vVy-v_K7Y8" bgImage="/img/video-cover-2.jpg"/>
            </div>
        </Container>
    </div>
</template>

<script>
import Video from '@/components/Video';

export default {
    name: 'SiteHero',

    components: { Video },
};
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.SiteHero {
    padding: 80px 0;
    background-color: $bg-color-4;
    position: relative;
    overflow: hidden;

    @include breakpoint(lg) {
        padding-bottom: 0;
    }

    &:before {
        @include overlay();
        content: '';
        background-image: url('/img/home/hero-bg.jpg');
        background-size: cover;
        background-position: center;
        opacity: 0.25;
        z-index: 1;
        filter: blur(1px);
    }

    .Container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 100%;
        position: relative;
        z-index: 1;

        @include breakpoint(lg) {
            flex-direction: column;
        }
    }

    .main {
        width: 100%;
        max-width: 450px;

        @include breakpoint(lg) {
            max-width: none;
            margin: 0 auto;
            text-align: center;
        }

        h1 {
            @extend %display-title;
            margin-bottom: 30px;
        }

        p {
            @extend %display-description;
        }

        .Button {
            margin-top: 60px;
        }
    }

    .aside {
        display: flex;
        width: 100%;
        margin-left: 60px;

        @include breakpoint(lg) {
            margin-top: 60px;
            margin-left: 0;
        }

        .Video {
            align-self: flex-end;
        }
    }
}
</style>
